; (function ($, document, window, undefined) {

  var windowWidth = $(window).outerWidth()

  $(window).on('resize', _.debounce(function (event) {
    windowWidth = $(window).outerWidth()
  }, 50))

  $.cookie.json = true

  function getFormCookie(key) {
    var data = $.cookie('reserve_form') || {}

    if (typeof key === undefined) {
      return data
    }

    return data[key] || null
  }

  function updateFormCookie(data) {
    $.cookie('reserve_form', Object.assign({}, getFormCookie(), data), { expires: 7 })
  }

  function clearFormCookie() {
    $.removeCookie('reserve_form')
  }

  // RESERVE FORM
  var reserveObj = {
    form: $('#reserve-form'),
    dateFromEl: $('#reserve-form .form-group[data-input="datefrom"]'),
    dateToEl: $('#reserve-form .form-group[data-input="dateto"]'),
    timeFromEl: $('#reserve-form .form-group[data-input="timefrom"] select'),
    timeToEl: $('#reserve-form .form-group[data-input="timeto"] select'),
    init: function () {
      var obj = this

      // datepicker
      obj.dateFromEl.daterangepicker({
        autoUpdateInput: false,
        autoApply: true,
        minDate: moment().format('MM/DD/YYYY'),
        maxDate: moment().add(11, 'months').format('MM/DD/YYYY'),
        template: '<div class="daterangepicker dropdown-menu">' +
        '<div class="calendar left"><div class="calendar-table"></div></div>' +
        '<div class="calendar right"><div class="calendar-table"></div></div>' +
        '</div>'
      })

      obj.dateFromEl.on('apply.daterangepicker', function (event, $daterangepicker) {
        updateFormCookie({
          start_date: moment($daterangepicker.startDate).format('MM/DD/YYYY'),
          end_date: moment($daterangepicker.endDate).format('MM/DD/YYYY')
        })
      })

      obj.dateFromEl.on('hide.daterangepicker', function (event, $daterangepicker) {
        obj.dateFromEl.removeClass('focus')
        obj.dateToEl.removeClass('focus')
      })

      obj.dateFromEl.on('setStartDate.daterangepicker', function (event, $daterangepicker) {
        obj.dateFromEl.find('input').val(moment($daterangepicker.startDate).format('MM/DD/YYYY')).trigger('change')
        obj.dateToEl.find('input').val('')
      })

      obj.dateFromEl.on('setEndDate.daterangepicker', function (event, $daterangepicker) {
        obj.dateToEl.find('input').val(moment($daterangepicker.endDate).format('MM/DD/YYYY')).trigger('change')
      })

      obj.dateFromEl.on('click', { obj, getFormCookie, updateFormCookie }, function (event) {
        var $this = $(this),
          input = $this.find('input'),
          $daterangepicker = $this.data('daterangepicker')

        $this.addClass('focus')

        if (!$daterangepicker.isShowing) {
          $daterangepicker.show()
        }
      })

      obj.dateToEl.on('click', { obj, getFormCookie, updateFormCookie }, function (event) {
        var $this = $(this),
          input = $this.find('input'),
          $daterangepicker = event.data.obj.dateFromEl.data('daterangepicker')

        $this.addClass('focus')

        if (!$daterangepicker.isShowing) {
          // $daterangepicker.endDate = input.val() ? moment(input.val()) : null
          input.val('')
          $daterangepicker.endDate = null
          $daterangepicker.show()
          $daterangepicker.move({ top: event.data.obj.dateFromEl.position().top - $this.position().top })
        }
      })

      obj.dateFromEl.find('input').on('change', { obj, getFormCookie, updateFormCookie }, function (event) {
        var date = $(this).val()

        if (date) {
          event.data.obj.dateFromEl.data('daterangepicker').setStartDate(date)
        }
      })

      obj.dateToEl.find('input').on('change', { obj, getFormCookie, updateFormCookie }, function (event) {
        var date = $(this).val()

        if (date) {
          event.data.obj.dateFromEl.data('daterangepicker').setEndDate(date)
        }
      })

      obj.dateFromEl.find('input').val(getFormCookie('start_date')).trigger('change')
      obj.dateToEl.find('input').val(getFormCookie('end_date')).trigger('change')

      // time
      obj.timeFromEl.val(getFormCookie('start_time') || obj.timeFromEl.val())
      obj.timeToEl.val(getFormCookie('end_time') || obj.timeToEl.val())

      obj.timeFromEl.on('change', { obj, getFormCookie, updateFormCookie }, function (event) {
        event.data.updateFormCookie({ start_time: $(this).val() })
      })

      obj.timeToEl.on('change', { obj, getFormCookie, updateFormCookie }, function (event) {
        event.data.updateFormCookie({ end_time: $(this).val() })
      })

      // form submit
      obj.form.on('submit', function (event) {
        var $form = $(this),
          errors = 0

        // check for errors
        $.each($form.find('[required]'), function (index, field) {
          var formGroup = $(field).closest('.form-group')

          if ($(field).val()) {
            formGroup.removeClass('error')
          } else {
            formGroup.addClass('error')
            errors++
          }
        })

        if (errors) {
          event.preventDefault()

          // scroll to form
          $('html, body').animate({
            scrollTop: $form.position().top
          })
        }
      })
    }
  }

  reserveObj.init()

  // TESTIMONIALS
  $('.testimonials-slider').lightSlider({
    item: 1,
    loop: true,
    adaptiveHeight: true,
    mode: 'fade',
    prevHtml: '&lt;',
    nextHtml: '&gt;',
    pager: false
  })

  // TOGGLE VISIBILITY
  $('[data-toggle]').on('click', function (event) {
    event.preventDefault()
    var $this = $(this),
      toggleEl = $($this.data('toggle'))

    toggleEl.toggle()
  })

  // RESERVE FORM SUBMIT
  $(document).on('click', 'a[href="#reserve"]', function (event) {
    event.preventDefault()
    $('#reserve-form').trigger('submit')
  })

  // MOBILE MENU
  var mobileMenu = $('#main-menu-mobile')
  $(document).on('click touchstart', function (event) {
    var target = $(event.target)

    if (
      mobileMenu.is(':visible')
      && target.attr('id') !== 'main-menu-mobile'
      && target.parents('.menu').attr('id') !== 'main-menu-mobile'
      && target.data('toggle') !== '#main-menu-mobile'
    ) {
      mobileMenu.hide()
    }
  })

  // helpers
  function scrollIntoView(el) {
    var viewTop = $(window).scrollTop(),
      viewBottom = viewTop + $(window).height(),
      elTop = el.offset().top,
      elBottom = elTop + el.outerHeight();

    if (!((elBottom <= viewBottom) && (elTop >= viewTop))) {
      $('html, body').animate({
        scrollTop: Math.floor(elBottom - viewBottom + 10)
      })
    }
  }

})(jQuery, window, document);



// WEBPACK FOOTER //
// ./src/js/main.js